import { render } from "./TaxService.vue?vue&type=template&id=44fec21d&scoped=true"
import script from "./TaxService.vue?vue&type=script&lang=js"
export * from "./TaxService.vue?vue&type=script&lang=js"

import "./TaxService.vue?vue&type=style&index=0&id=44fec21d&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fec21d"]])

export default __exports__